<div class="page-content page-content-after-header task-container">
  <div class="row">
    <div class="col-6"></div>
    <div class="col-6 right task-sort">
      <div ngbDropdown #theDropdown="ngbDropdown" (openChange)="toggleSort()" placement="bottom-end">
        <input readonly="readonly" class="task-dropdown" [ngClass]="sortOpened ? 'opened' : ''" placeholder="Sort By"
          autocomplete="off" autocorrect="off" ngbDropdownToggle />
        <div ngbDropdownMenu class="pre-scrollable">
          <button (click)="onSortChange(sortType);theDropdown.close();" *ngFor="let sortType of sortTypes"
            id="{{ sortType }}" ngbDropdownItem>{{ sortType }}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="no-task-message" *ngIf="!tableHasData">
    There’s currently no Branch Tasks that need reviewing. You may need to refresh to see new Branch Tasks.
  </div>
  <div class="row task-grid-header" *ngIf="tableHasData">
    <div class="col-1" *ngIf="isEditing">Select All</div>
    <div class="col-2">Task Type</div>
    <div class="col-3">Customer's Name</div>
    <div class="col-2">Date & Time of Appointment</div>
    <div [ngClass]="isEditing ? 'col-2' : 'col-3'">VRM</div>
    <div class="col-2">Branch</div>
  </div>
  <div class="row task-grid-row" *ngFor="let task of pagedTasks; let i = index" (click)="actionTask(task)">
    <div class="col-1" *ngIf="isEditing"></div>
    <div class="col-2 task-type" [ngClass]="taskService.getTaskClass(task)">{{ task.taskType }}</div>
    <div class="col-3 obfuscated-playback">{{ task.customerName }}</div>
    <div class="col-2">{{ task.appointmentDate | date: "dd/MM/yyyy HH:mm" }}</div>
    <div [ngClass]="isEditing ? 'col-2' : 'col-3'">{{ task.vrm }}</div>
    <div class="col-2">{{ task.branch }}</div>
  </div>

  <app-pager [pageCount]="pageCount" [currentPage]="currentPage"></app-pager>
</div>